import { flow, types } from 'mobx-state-tree'
import { actions } from '@sr/routes/common'
import { BaseRouteState, Policy, SocialReferent } from '@shared/data-access'

export const MonitoringAreaRouteState = BaseRouteState.named(
  'MonitoringAreaRouteState'
)
  .props({
    policyId: types.maybeNull(types.string),
    policy: types.maybeNull(types.reference(Policy)),
    roomSid: types.maybeNull(types.string),
    user: types.maybeNull(types.reference(SocialReferent)),
  })
  .actions((self) => ({
    ...actions(self),
    afterAttach() {
      self.loadMonitoringDependencies()
    },
    loadMonitoringDependencies: flow(function* loadMonitoringDependencies() {
      self.setLoading('MonitoringAreaRouteState')
      try {
        yield Promise.all([
          self.loadPolicy(),
          self.getTwilioRoomSeed(),
          self.loadUserInfo(),
        ])
      } finally {
        self.removeLoading('MonitoringAreaRouteState')
      }
    }),
  }))
